import {useQuery} from 'react-query';
import {
  PaymentMethodChoices,
  PaymentMethodValues,
} from '../../../pages/shopping-basket/cash-payment/utils/helpers';
import {CreditPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import {getOrderCreditTransactionPrice} from './getStoreOrderCreditTransactionPrice';

const useGetOrderCreditTransactionPrice = ({
  orderGuid,
  paymentType,
  handleAfterSuccess,
  enabled = true,
}: {
  orderGuid?: string;
  paymentType?: PaymentMethodValues;
  handleAfterSuccess?: (data: CreditPaymentResponse) => void;
  enabled?: boolean;
}) => {
  const {data, isLoading, refetch, isSuccess, isFetching} =
    useQuery<CreditPaymentResponse>(
      ['get-order-credit-transaction-price', orderGuid, paymentType],
      () => getOrderCreditTransactionPrice(orderGuid, paymentType),
      {
        enabled: Boolean(orderGuid) && enabled,
        onSuccess: data => handleAfterSuccess?.(data),
      },
    );
  return {data, isLoading, refetch, isSuccess, isFetching};
};

export default useGetOrderCreditTransactionPrice;
